import React from 'react'
import './Common_title.css'

const Common_title = (props) => {
    return (
        <>
            <div className='commontitle_div'>
                <p className='maintitle'>{props.title}</p>
                <h5 className='subtitle'>{props.subtitle} <img className='titlelogo' src={props.logo} /></h5>

            </div>
        </>
    )
}

export default Common_title